import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-token',
  templateUrl: './view-token.component.html',
  styleUrls: ['./view-token.component.css']
})
export class ViewTokenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
